import Slider from "react-slick";
import { Card } from "../component/ui/Card";
import { Star } from "lucide-react";

const reviews = [
  {
    name: "Jeannette Mazerolle",
    review:
      "My husband ordered a last minute cake for my birthday. Not only was it done for the next day but it was beautiful and one of the most delicious cakes I've ever eaten. Highly recommend!!",
    rating: 5,
    time: "3 weeks ago"
  },
  {
    name: "Bhoomi Desai",
    review:
      "I absolutely loved the cake from Nice Yumm Cake! 🎂 It was fresh, soft, and beautifully decorated. The flavor was perfect — not too sweet, just the right balance. Everyone at my party enjoyed it and kept asking where it was from. Highly recommend!",
    rating: 5,
    time: "2 weeks ago"
  },
  {
    name: "Kaur Prabh",
    review:
      "I ordered a cake from khushi’s Kbakery 1st time for my special person. This is very very delicious and presenting very well. Also, the prices are so genuine and cheap. I love it.",
    rating: 5,
    time: "1 month ago"
  },
  {
    name: "deepa korotania",
    review:
      "I would really recommend to order cake from her. She is fantastic at her job and the best part was we called her on the last minute still got the best one.",
    rating: 5,
    time: "1 week ago"
  },
  {
    name: "Kathan Trivedi",
    review:
      "The desserts are absolutely amazing! The cupcakes are soft and flavorful, the kunafa has the perfect balance of sweetness and crunch, and the brownies are rich and indulgent. Everything is fresh, high-quality, and beautifully made. Highly recommend.",
    rating: 5,
    time: "1 month ago"
  },
  {
    name: "Palak Shrimali",
    review: "Absolutely delicious! The cake was incredibly moist, fresh, and had the perfect balance of sweetness.",
    rating: 5,
    time: "1 month ago"
  },
  {
    name: "Connie F",
    review:
      "I came across K bakery at the Farmers Market. The desserts looked very appealing. Wow, I was very impressed!! Not only delicious, they are eggless desserts. Highly recommend!",
    rating: 5,
    time: "1 month ago"
  },
  {
    name: "vyas rupal",
    review:
      "I wanted to order something last minute and she just made my whole situation very smooth as I was very stressed out but k bakery is just amazing very helpful and also that last minute order was just fingerlicking good.",
    rating: 5,
    time: "1 month ago"
  },
  {
    name: "aarav joshi",
    review:
      "Tried the mango dessert 😜 it was lovely...tried Hazelnut Cake...really really delicious...every time I order something it's a great experience for me and my friends.",
    rating: 5,
    time: "1 month ago"
  },
  {
    name: "Brinda Trivedi",
    review:
      "Heyy khushi you are awesome baker!! ❤️❤️ I really like your chocolate walnut brownies and kunafa brownies. Please start shipping your brownies across US.",
    rating: 5,
    time: "1 month ago"
  },
  {
    name: "Harmanpreet Manan",
    review:
      "I ordered pineapple cake from K bakery for my sister birthday, it's so yummy. Bread is soft and fresh. Everyone liked it.",
    rating: 5,
    time: "1 month ago"
  },
  {
    name: "Pooja pooja",
    review:
      "I have tried rasmalai cake which was so delicious 😋, soft and spongy inside. Most important it was eggless which was a dream to get eggless cake in Lethbridge before Khushi bakery.",
    rating: 5,
    time: "1 month ago"
  },
  {
    name: "dharmistha dhadhi",
    review: "Best brownies I have ever had!!! Really amazing and must try. 🥳🤩",
    rating: 5,
    time: "1 month ago"
  },
  {
    name: "pratha patel",
    review: "Love the desserts can’t wait to try them again ❤️",
    rating: 5,
    time: "1 month ago"
  },
  {
    name: "AMNEL TSEGY",
    review: "It was delicious and tasty cake amazing.",
    rating: 5,
    time: "1 hour ago"
  }
];

// Settings for Desktop/Large Screens (3 slides, center mode)
const desktopSettings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 4000,
  centerMode: true,
  centerPadding: "0px",
  responsive: [
    {
      // Maintain 3 slides for screens 1024px and up
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        centerMode: true,
      }
    },
    // No need for a 768px setting here, as this slider is hidden below 768px
  ]
};

// Settings for Mobile/Small Screens (1 slide, no center mode)
const mobileSettings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1, // Only 1 slide
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 4000,
  centerMode: false, // CRITICAL: No center mode for single slide
  centerPadding: "0px",
};

export default function Testimonials() {
  const renderReviewCard = (r, i) => (
    <div key={i} className="px-3 pb-6">
      <Card className="p-8 my-4 rounded-2xl shadow-md transition-transform hover:scale-105 min-h-[320px] flex flex-col justify-between">
        <p className="text-gray-600 italic mb-4 font-inter">“{r.review}”</p>
        <div className="flex justify-center mb-3">
          {Array.from({ length: r.rating }).map((_, i2) => (
            <Star key={i2} className="w-4 h-4 text-rose-400 fill-rose-400" />
          ))}
        </div>
        <div className="font-serif font-semibold text-gray-800">{r.name}</div>
        {/* <div className="text-sm text-gray-500 font-inter">{r.time}</div> */}
      </Card>
    </div>
  );

  return (
    <section className="bg-gradient-to-b from-pink-50 via-white to-orange-50 py-20 text-center">
      <h2 className="text-5xl md:text-6xl font-serif font-normal text-gray-800">
        What Our <br/><span className="text-rose-400">Customers Say</span>
      </h2>

      <div className="mt-10 max-w-6xl mx-auto px-6">
        
        {/* 1. DESKTOP SLIDER: Shows only on large screens (sm and up) 
          The 'hidden' utility hides it by default (on mobile), and 'sm:block' shows it on screens 640px and wider.
        */}
        <div className="hidden sm:block">
          <Slider {...desktopSettings}>
            {reviews.map(renderReviewCard)}
          </Slider>
        </div>

        {/* 2. MOBILE SLIDER: Shows only on small screens 
          The 'sm:hidden' utility hides it on screens 640px and wider.
          We use mx-[-15px] to counteract any minor padding/margin issues from react-slick.
        */}
        <div className="sm:hidden mx-[-15px]"> 
          <Slider {...mobileSettings}>
            {reviews.map(renderReviewCard)}
          </Slider>
        </div>
      </div>

      {/* Custom CSS for center zoom effect */}
      <style jsx global>{`
        /* This rule only applies to the desktop slider because the mobile slider has centerMode: false */
        .slick-center .p-8 {
          transform: scale(1.05);
          transition: transform 0.3s;
        }
        .slick-slide {
          transition: transform 0.3s;
        }
      `}</style>
    </section>
  );
}